import { render, staticRenderFns } from "./phone.vue?vue&type=template&id=463ec175&scoped=true&"
var script = {}
import style0 from "./phone.vue?vue&type=style&index=0&id=463ec175&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463ec175",
  null
  
)

export default component.exports